import ColorPicker from "components/ColorPicker"
import { SingleSelectField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FONTS } from "constants/fonts"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState, useRef} from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row, Tooltip } from "reactstrap"
import { Field, isDirty, reset } from "redux-form"
const BrandingTab = ({ isDirty, resetForm, tabIsActive, handleSave }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [showAlertModal, setShowAlertModal] = useState(false)

  const toggle = () => setTooltipOpen(!tooltipOpen)
  const rowRef = useRef(null);
  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>Add brand colors and fonts</h4>
        </CardHeader>
        <CardBody>
          <Row className="my-3" ref={(element) => {
            if (element) {
              element.style.setProperty('margin-bottom', '0px', 'important');
            }
            rowRef.current = element;
          }}>
            <Col xs={12} md={3} style={{ minWidth: "fit-content" }}>
              <label style={{ width: "150px" }}>
                Primary Menu Color:&nbsp;
                <i className="fas fa-question-circle" id="primaryColor"></i>
                &nbsp;
              </label>
              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target="primaryColor"
                toggle={toggle}
              >
                <b>NOTE:</b> Do not select white as your primary color
              </Tooltip>
            </Col>
            <Col xs="auto">
              <Field
                name="primaryMenuColor"
                type="color"
                component={ColorPicker}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={3} style={{ minWidth: "fit-content" }}>
              <label style={{ width: "150px" }}>Secondary Text Color:</label>
            </Col>
            <Col xs="auto">
              <Field
                name="secondaryTextColor"
                type="color"
                component={ColorPicker}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={3} style={{ minWidth: "fit-content" }}>
              <label style={{ width: "150px" }}>Brand Font:</label>
            </Col>
            <Col xs="auto">
              <div style={{ width: "270px" }}>
                <Field
                  className="full-width"
                  name="font"
                  component={SingleSelectField}
                  options={FONTS.map(font => ({
                    value: font.value,
                    label: font.text,
                  }))}
                  placeholder="Select Font Family"
                />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDirty: isDirty(FORM_NAMES.PLATFORM_SETTINGS)(
    state,
    ...["design.primaryMenuColor", "design.secondaryTextColor", "design.font"]
  ),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.PLATFORM_SETTINGS)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BrandingTab)
